import {
    WASTAGE_SAVE,
    WASTAGE_SAVE_SUCCESS,
    WASTAGE_SAVE_FAIL,
    WASTAGE_FILTER,
    WASTAGE_FILTER_SUCCESS,
    WASTAGE_FILTER_FAIL,
    WASTAGE_SINGLE_GET,
    WASTAGE_UPDATE,
    WASTAGE_DELETE,
    WASTAGE_SINGLE_GET_SUCCESS,
    WASTAGE_DELETE_SUCCESS,
    WASTAGE_UPDATE_SUCCESS,
    WASTAGE_UPDATE_FAIL,
    WASTAGE_EXCEL_REPORT,
    WASTAGE_EXCEL_REPORT_SUCCESS,
    WASTAGE_EXCEL_REPORT_FAIL
  } from "./actionType";
  
  // SAVE
  export const wastageSave = (jsonBody) => ({
    type: WASTAGE_SAVE,
    payload: jsonBody,
  });
  
  export const wastageSaveSuccess = (response) => ({
    type: WASTAGE_SAVE_SUCCESS,
    payload: response,
  });
  
  export const wastageSaveFail = (error) => ({
    type: WASTAGE_SAVE_FAIL,
    payload: error,
  });
  
  // FILTER
  export const wastageFilter = (jsonBody) => ({
    type: WASTAGE_FILTER,
    payload: jsonBody,
  });
  
  export const wastageFilterSuccess = (response) => ({
    type: WASTAGE_FILTER_SUCCESS,
    payload: response,
  });
  export const wastageSingleGetSuccess = (payload) => ({
    type: WASTAGE_SINGLE_GET_SUCCESS, // 👈 MUST be different
    payload,
  });
  
  export const wastageFilterFail = (error) => ({
    type: WASTAGE_FILTER_FAIL,
    payload: error,
  });
  export const editWastageList = (config={}) => ({
    type: WASTAGE_SINGLE_GET,
    config,
  })
  
  export const updateWastageList = (payload = {}) => ({
    type: WASTAGE_UPDATE,
    payload,
  });
  
  export const updateWastageListSuccess = (resp) => ({
    type: WASTAGE_UPDATE_SUCCESS,
    payload: resp,
  });
  
  export const deleteWastageId = (config={}) => ({
    type: WASTAGE_DELETE,
    config,
  });
  
  export const deleteWastageIdSuccess = (resp) => ({
    type: WASTAGE_DELETE_SUCCESS,
    payload: resp,
  });

  export const updateWastageListFail = (error) => ({
    type: WASTAGE_UPDATE_FAIL,
    payload: error,
  });

  export const wastageExcelReport = (jsonBody) => ({
    type: WASTAGE_EXCEL_REPORT,
    payload: jsonBody,
});

export const wastageExcelReportSuccess = (response) => ({
    type: WASTAGE_EXCEL_REPORT_SUCCESS,
    payload: response,
});

export const wastageExcelReportFail = (error) => ({
    type: WASTAGE_EXCEL_REPORT_FAIL,
    payload: error,
});
  